const CACHE_TIME = {
    FIVE_MIN: 5 * 60 * 1000,
    FIFTEEN_MIN: 15 * 60 * 1000,
    THIRTY_MIN: 30 * 60 * 1000,
    ONE_HOUR: 60 * 60 * 1000,
    ONE_DAY: 24 * 60 * 60 * 1000
};

export { CACHE_TIME };
export default CACHE_TIME;